import createClient, { type Client } from 'openapi-fetch';
import type { paths } from './schema.ts';

export type { components, paths } from './schema.ts';
export type ApiClient = Client<paths>;

export interface ApiClientOptions {
  baseUrl: string;
  /** Returns the current access token, or null when signed out (public mode). */
  getToken?: () => Promise<string | null> | string | null;
  fetch?: typeof globalThis.fetch;
}

/* The typed client every TypeScript surface uses (mobile, admin, twin). Generated types, hand-written glue. */
export function createApiClient(options: ApiClientOptions): ApiClient {
  const client = createClient<paths>({
    baseUrl: options.baseUrl,
    ...(options.fetch ? { fetch: options.fetch } : {}),
  });
  client.use({
    async onRequest({ request }) {
      const token = await options.getToken?.();
      if (token) request.headers.set('authorization', `Bearer ${token}`);
      return request;
    },
  });
  return client;
}
